import styles from "./home.module.css";
import Hero from "./Hero"; 
import About from "./About"; 
import Portfolio from "./Portfolio"; 
import Services from "./Services";  
import Testimonials from "./Testimonials";
import Contact from "./Contact";
import AnimatedReveal from '../../Components/AnimatedReveal/AnimatedReveal';
import flower1 from '../../assets/flower1.png';
import flower2 from '../../assets/flower2.png';
import flower3 from '../../assets/flower3.png';
import flower4 from '../../assets/flower4.png';
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen';
function Home() {
  const isSmallScreen = useIsSmallScreen();
  return (
    <div className={styles.backgroundGrain}>
      <div className={styles.homeContainer}>
        <AnimatedReveal><Hero /></AnimatedReveal>
        <AnimatedReveal><About /></AnimatedReveal>
        <AnimatedReveal><Portfolio /></AnimatedReveal>
        <AnimatedReveal><Services /></AnimatedReveal>
        <AnimatedReveal><Testimonials /></AnimatedReveal>
        <AnimatedReveal><Contact /></AnimatedReveal>
        {!isSmallScreen && (
          <>
            <img src={flower1} alt="flower1" className={styles.flower1}/>
            <img src={flower2} alt="flower2" className={styles.flower2}/>
            <img src={flower3} alt="flower3" className={styles.flower3}/>
          </>
        )}
        <img src={flower4} alt="flower4" className={styles.flower4}/>

      </div>
    </div>

  );
}

export default Home;